import React, { Fragment } from 'react';

import {
  Tooltip,
  Avatar,
  Box,
  Card,
  Grid,
  colors,
  Icon,
  makeStyles,
  CardContent,
  Typography,
  Divider,
  Button,
  IconButton
} from '@material-ui/core';

import { BsSpeedometer2 } from "react-icons/bs";
import { FaWaveSquare } from "react-icons/fa";
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';

const useStyles = makeStyles((theme) => ({
  root: {
  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200],
    width: 50,
    height: 50
  }
}));

const Results = ({ list, openEdition, openDeletion }) => {

  const classes = useStyles();

  return (
    <Fragment>
      <Box mt={3}>
        <Grid
          container
          spacing={3}
        >
          {list.map((panel, index) => (
            <Grid
              item
              key={panel._id}
              lg={4}
              md={6}
              xs={12}
            >

              <Card className={classes.root}>

                <CardContent>
                  <Box
                    display="flex"
                    justifyContent="center"
                    mb={3}
                  >

                    <Avatar
                      className={classes.avatar}
                    >
                      {<Icon component={BsSpeedometer2} style={{ color: colors.indigo[400] }} ></Icon>}
                    </Avatar>
                  </Box>

                  <Typography
                    align="center"
                    color="textPrimary"
                    gutterBottom
                    variant="h4"
                  >
                    <b>{panel.code}</b>
                  </Typography>

                  <Typography
                    align="center"
                    color="textPrimary"
                    variant="body1"
                  >
                    {panel.title}
                  </Typography>

                  <Typography
                    align="center"
                    color="secondary"
                    variant="h5"
                  >
                    <b>Protocolo de Dispositivo:</b> {panel.message}
                  </Typography>

                  <Typography
                    align="center"
                    color="textSecondary"
                    variant="h5"
                  >
                    <b>Instrumentos:</b> ({(panel.instruments) ? panel.instruments.length : 0})
                  </Typography>

                </CardContent>

                <Divider />

                <Box p={1}>
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    spacing={1}
                  >

                    <Grid
                      item
                      className={classes.statsItem}
                    >
                      <Tooltip title="Editar campo de entrada">
                        <IconButton
                          color="secondary"
                          className={classes.btntreatment}
                          children={<EditRoundedIcon />}
                          size="medium"
                          onClick={() => { openEdition(panel) }}></IconButton>
                      </Tooltip>
                      <Tooltip title="Excluir Operação">
                        <IconButton
                          color="secondary"
                          className={classes.btntreatment}
                          children={<DeleteRoundedIcon />}
                          size="medium"
                          onClick={() => { openDeletion(panel) }}></IconButton>
                      </Tooltip>

                    </Grid>

                    <Grid
                      className={classes.statsItem}
                      item
                    >
                      <Tooltip title="Visualizar protocolo de dispositivo">
                        <Button
                          color="secondary"
                          startIcon={<Icon component={FaWaveSquare} style={{ color: colors.blue[400] }} ></Icon>}
                          size="small"
                          variant="text">
                          Protocolo
                        </Button>

                      </Tooltip>
                    </Grid>
                  </Grid>
                </Box>
              </Card>

            </Grid>
          ))}
        </Grid>
      </Box>
    </Fragment >
  );
};

export default Results;
